import store from '../store/index';
var request = require('request');
var contextInstance = require('./ContextInstance.js').default;
var settingsInstance = require('./SettingsInstance.js');

export function mergeQueryParams(parameters, queryParameters) {
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      var parameter = parameters.$queryParameters[parameterName];
      queryParameters[parameterName] = parameter;
    });
  }
  return queryParameters;
}

export function customRequest(
  method,
  path,
  url,
  body,
  headers,
  queryParameters,
  form,
  deferred,
  files,
  options
) {
  let statusCallbacks = {
    401: _ => {
      contextInstance.login();
    },
    403: _ => contextInstance.setGlobalErrorData(403),
    404: _ => contextInstance.setGlobalErrorData(404),
    500: _ => contextInstance.setGlobalErrorData(500)
  };

  let req = {
    method: method,
    uri: url,
    qs: queryParameters,
    headers: headers
  };
  if (body) {
    req = { ...req, body: body };
  }
  if (typeof body === 'object' && !(body instanceof Buffer)) {
    req.json = true;
  }

  if (options && options.encoding) {
    req.encoding = options.encoding;
  }

  if (Object.keys(files).length > 0) {
    req.formData = new FormData();
    for (var formKey in form) {
      req.formData.append(formKey, form[formKey]);
    }
    for (var fileKey in files) {
      req.formData.append(fileKey, files[fileKey]);
    }
  } else if (Object.keys(form).length > 0) {
    req.form = form;
  }

  let csrfToken = contextInstance.getCsrfToken();
  req.headers['X-CSRFToken'] = csrfToken;

  req.withCredentials = true;

  if (options != undefined && options.withCredentials != undefined) {
    req.withCredentials = options.withCredentials;
  }
  if (options != undefined && options.hasCsrfToken == false) {
    delete req.headers['X-CSRFToken'];
  }
  if (options != undefined && options.hasContentType == false) {
    delete req.headers['Accept'];
  }

  if (req.formData) {
    var url = req.uri;
    if (Object.keys(req.qs).length > 0) {
      url += '?';
      for (var qsKey in req.qs) {
        let qs = qsKey + '=' + encodeURIComponent(req.qs[qsKey]);
        url += url.slice(-1) === '?' ? qs : '&' + qs;
      }
    }
    var xhr = new XMLHttpRequest();
    if (options && options.cancelToken) {
      req.cancelToken = options.cancelToken;
      req.cancelToken.cancel = function() {
        xhr.abort();
        deferred.reject(new Error('Cancelled by user'));
      };
    }

    xhr.onload = _ => {
      var body;
      if (xhr.response) {
        try {
          body = JSON.parse(xhr.response);
        } catch (e) {}
      }
      if (statusCallbacks[xhr.status]) {
        statusCallbacks[xhr.status]();
      } else if (xhr.status >= 200 && xhr.status <= 299) {
        contextInstance.clearGlobalError();

        deferred.resolve({
          response: xhr.response,
          body: body
        });
      } else {
        contextInstance.clearGlobalError();

        deferred.reject({
          response: xhr.response,
          body: body
        });
      }
    };
    xhr.upload.onerror = error => {
      deferred.reject({
        response: error
      });
    };
    xhr.upload.onprogress = progress => {
      deferred.notify(Math.round((progress.loaded * 100) / progress.total));
    };

    xhr.open(req.method, url);
    xhr.setRequestHeader('X-CSRFToken', csrfToken);
    xhr.withCredentials = true;
    xhr.send(req.formData);
  } else {
    request(req, function(error, response, body) {
      if (error) {
        deferred.reject(error);
      } else {
        if (
          /^application\/(.*\\+)?json/.test(response.headers['content-type'])
        ) {
          try {
            body = JSON.parse(body);
          } catch (e) {}
        }

        const showGlobalErrors =
          !options || (options && !options.ignoreGlobalErrors);
        if (statusCallbacks[response.statusCode] && showGlobalErrors) {
          statusCallbacks[response.statusCode]();
        } else if (response.statusCode === 204) {
          contextInstance.clearGlobalError();

          deferred.resolve({
            response: response
          });
        } else if (response.statusCode >= 200 && response.statusCode <= 299) {
          contextInstance.clearGlobalError();

          if (body == 'Włączono tryb tylko od odczytu') {
            if (response.request.method != 'GET') {
              deferred.reject({
                body: {
                  error: 'Włączono tryb tylko do odczytu'
                }
              });
            } else {
              deferred.resolve({
                response: response,
                body: body
              });
            }
          } else {
            deferred.resolve({
              response: response,
              body: body
            });
          }
        } else {
          contextInstance.clearGlobalError();

          deferred.reject({
            response: response,
            body: body
          });
        }
      }
    });
  }
}
